<template>
  <van-overlay show z-index="1000">
    <div class="w-full h-full bg-white authorization">
      <div>
        <span>为了提供更好的服务，申请获得</span>
      </div>
      <div class="mt-5 mb-8">
        <span class="text-large-x">以下权限</span>
      </div>
      <div>
        <van-icon name="passed" />
        <span class="ml-3">获取您的昵称、头像</span>
      </div>
      <div class="px-5" style="padding-top: 30vh">
        <van-button class="auth-btn mt-5" block type="primary" @click="onLogin">
          <span>同意</span>
        </van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'Authorization',
  methods: {
    onLogin() {
      this.$answerUtil.wxAuthorization(null)
    }
  },
  beforeCreate() {
    document.title = '申请获取您的公开信息'
  }
}
</script>

<style scoped lang="scss">
.authorization {
  font-size: 16px;
  padding: 40px 20px;
  box-sizing: border-box;

  .auth-btn {
    width: 184px;
    margin: 0 auto;
    background-color: #07c160 !important;
    border: 1px solid #07c160 !important;
    position: relative;
    box-sizing: border-box;
    font-weight: 700;
    font-size: 17px;
    text-align: center;
    text-decoration: none;
    color: #fff;
    border-radius: 4px;
    overflow: hidden;
    height: 36px !important;
  }
}
</style>
